<div
  [ngClass]="{
    'pointer-events-none opacity-50': disabled,
    'opacity-100': !disabled,
  }">
  <form [formGroup]="form">
    <div class="border-neutral-90 mb-2 mt-2 rounded-lg border border-solid p-4">
      <div class="flex items-start justify-between">
        <div
          class="quick-search h-[36px] w-2/3 items-center rounded-lg md:h-[40px]"
          aria-label="Search listbox form field">
          <input
            matInput
            (input)="updateSearchTerm($event)"
            [placeholder]="'global.search' | translate"
            aria-label="Search listbox" />
          <mat-icon class="mr-2" aria-label="Search icon" matPrefix>search </mat-icon>
        </div>
        <app-button
          [shape]="ButtonShape.ROUNDED"
          [color]="ButtonColor.PRIMARY"
          [style]="ButtonStyle.FILLED"
          [icon]="'add'"
          class="shaded"
          aria-label="Add item"
          (click)="addItem()" />
      </div>

      <div *ngIf="filteredList$ | async as filteredList">
        <div class="max-h-[calc(100%-770px)] overflow-auto" *ngIf="filteredList.length > 0; else empty">
          @for (item of filteredList; track item.id; let i = $index) {
            <div #field>
              <mat-form-field class="h-16 w-full" appearance="fill">
                <input
                  matInput
                  [formControlName]="item.id"
                  [placeholder]="label | translate"
                  [appDuplicateName]="item.duplicateNames || []" />
                <mat-error [attr.aria-label]="'Error message for item control'" *ngIf="form.get(item.id)?.errors">
                  <ng-template [appMatErrorMessages]="form.get(item.id)" let-message>{{ message }} </ng-template>
                </mat-error>
                <span *ngIf="!item.id.includes('field_') && form.get(item.id)?.untouched" class="mr-2 flex" matSuffix>
                  <mat-icon
                    class="material-icons-outlined primary-sublabel mx-2 cursor-pointer"
                    aria-label="Save item"
                    (click)="editItem(item.id)"
                    >edit</mat-icon
                  >
                  <mat-icon
                    class="material-icons-outlined primary-sublabel mx-2 cursor-pointer"
                    aria-label="Delete item"
                    (click)="deleteItem(item.id)"
                    >delete</mat-icon
                  >
                </span>
                <span
                  *ngIf="item.id.includes('field_') || form.get(item.id)?.touched"
                  class="mr-2 flex cursor-pointer"
                  matSuffix>
                  <button (click)="deleteItem(item.id, true)" class="error-label mx-2">
                    {{ 'global.cancel' | translate }}
                  </button>
                  <button
                    [disabled]="form.get(item.id)?.errors"
                    (click)="emitConfirm(item.id)"
                    class="mx-2"
                    [ngClass]="form.get(item.id)?.errors ? 'secondary-label' : 'ternary-label'">
                    {{ 'global.confirm' | translate }}
                  </button>
                </span>
              </mat-form-field>
            </div>
          }
        </div>
      </div>

      <ng-template #empty>
        <div class="flex h-full w-full flex-wrap justify-center">
          <p>{{ 'global.noItemsFound' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </form>
</div>
